
export function handleScrollButtonCLick() {
    $('#scroll_to').on('click', function() {
        var scrollPosition = $('#anchor_ihre_vorteile').offset().top;
        var pos = 0;
        var id = setInterval(frame);
        var documentWidth = document.body.clientWidth;
        if (documentWidth > 1023) {
            scrollPosition = scrollPosition - 85;
        } else if (documentWidth > 767) {
            scrollPosition = scrollPosition - 80;
        } else {
            scrollPosition = scrollPosition - 60;
        }
        function frame() {
            if (pos >= scrollPosition) {
                clearInterval(id);
            } else {
                pos+= 8;
                window.scrollTo(0, pos);
            }
        }
        document.getElementById("scroll_to").style.display = "none";
    })

}

export function hideButtonOnScroll() {
    document.addEventListener("scroll", function (event) {
        document.getElementById("scroll_to").style.display = "none";
    })
}